import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import Brand from "./Brand.graphql";

export default function useBrands(id) {
    return useQuery(
        gql(Brand),
        {
            skip: id === undefined,
            variables: {
                id,
            },
        },
    );
}
